<form class="form-horizontal" name="frmConnectGeosparql" role="form">
  <hs-common-url type="geosparql" [(url)]="data.url" (connect)="connect()">
  </hs-common-url>
  <hs-url-progress *ngIf="hsAddDataCommonService.loadingInfo"></hs-url-progress>
  <div *ngIf="!validEndpoint">
    <p class="text-danger">{{'ADDLAYERS.GEOSPARQL.invalidEndpoint' | translateHs }}</p>
  </div>

  <div *ngIf="showDetails">
    <hr class="mb-3">
    <div class="form-floating mb-3">
      <textarea class="form-control" id='hs-ows-abstract'
        [placeholder]="'ADDLAYERS.GEOSPARQL.fillInQuery' | translateHs  " name="query" [(ngModel)]="data.query"
        (input)="findParamsInQuery()">
        </textarea>
      <label for="query" class="capabilities_label control-label">{{'COMMON.query' | translateHs }}</label>
    </div>

    <div class="mb-3">
      <p class="text-secondary" [hidden]="data.properties === undefined || data.properties.length === 0">
        {{'ADDLAYERS.GEOSPARQL.pickGeomParamPt1' | translateHs }}
        <strong>{{'ADDLAYERS.GEOSPARQL.pickGeomParamName' | translateHs }}</strong>
        {{'ADDLAYERS.GEOSPARQL.pickGeomParamPt2' | translateHs }}
      </p>
      <ng-container *ngFor="let variable of data.properties">
        <input type="radio" class="btn-check" name="variables" id="var-geom-{{variable}}" autocomplete="off"
          [(ngModel)]="data.geomProperty" [value]="variable">
        <label class="btn btn-sm"
          [ngClass]="[data.geomProperty === variable ? 'btn-success' : 'btn-outline-primary', data.idProperty === variable ? 'disabled' : '']"
          for="var-geom-{{variable}}">?{{variable}}</label>
        &nbsp;
      </ng-container>
    </div>

    <div class="mb-3">
      <p class="text-secondary" [hidden]="data.properties === undefined || data.properties.length === 0">
        {{'ADDLAYERS.GEOSPARQL.pickIdParamPt1' | translateHs }} <strong>{{'ADDLAYERS.GEOSPARQL.pickIdParamName' |
          translateHs }}</strong> {{'ADDLAYERS.GEOSPARQL.pickIdParamPt2' | translateHs }}
      </p>
      <ng-container *ngFor="let variable of data.properties">
        <input type="radio" class="btn-check" name="variables" id="var-id-{{variable}}" autocomplete="off"
          [(ngModel)]="data.idProperty" [value]="variable">
        <label class="btn btn-sm"
          [ngClass]="[data.idProperty === variable ? 'btn-success' : 'btn-outline-primary', data.geomProperty === variable ? 'disabled' : '']"
          for="var-id-{{variable}}">?{{variable}}</label>
        &nbsp;
      </ng-container>
    </div>

    <hs-new-layer-form [data]="data"></hs-new-layer-form>

    <hs-add-to-map [disabled]="!(data.geomProperty && data.idProperty && data.title)" (add)="add()"
      [title]="'ADDLAYERS.addSelected'"></hs-add-to-map>
  </div>

  <!--
    <button class="btn btn-primary w-100 mt-2" [disabled]="!data.geomProperty" (click)="hsUrlGeoSparqlService.runQuery()"><i
        class="icon-link"></i>
      {{'ADDLAYERS.GEOSPARQL.sendQuery' | translateHs }}
    </button>
  -->

</form>
